import { render, staticRenderFns } from "./CardFaceList.vue?vue&type=template&id=1ee3a84b&scoped=true&"
import script from "./CardFaceList.vue?vue&type=script&lang=js&"
export * from "./CardFaceList.vue?vue&type=script&lang=js&"
import style0 from "./CardFaceList.vue?vue&type=style&index=0&id=1ee3a84b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee3a84b",
  null
  
)

export default component.exports